// Appwrite's error codes are a backend's vocabulary. This is where they stop
// being one.
//
// A Record over the closed AuthErrorCode union, so a new code is a compile
// error here — at the one place that has to write a sentence for it — rather
// than a string that reaches a learner. `unknown` is a real catalog entry,
// NOT a runtime fallback: t() still throws on a miss, on both string surfaces.

import type { UiKey } from "../i18n/en.ts";
import { AuthError, type AuthErrorCode } from "./source.ts";

export const AUTH_ERROR_KEY: Record<AuthErrorCode, UiKey> = {
	emailTaken: "auth.errEmailTaken",
	rateLimited: "auth.errRateLimited",
	invalidToken: "auth.errInvalidToken",
	network: "auth.errNetwork",
	forbidden: "auth.errForbidden",
	transient: "auth.errTransient",
	invalidEmail: "auth.errInvalidEmail",
	accountLocked: "auth.errAccountLocked",
	unknown: "auth.errUnknown",
};

/** Anything a rejected auth promise can carry, turned into one catalog key. */
export const errorKey = (e: unknown): UiKey =>
	e instanceof AuthError ? AUTH_ERROR_KEY[e.code] : AUTH_ERROR_KEY.unknown;
